var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.tagName,
          expression: "tagName"
        }
      ],
      staticClass: "ig--content-desc row row-center"
    },
    [
      _c(
        "div",
        {
          staticClass: "desc-name",
          style: { "background-color": _vm.mColor(10), color: _vm.mColor(2.1) }
        },
        [
          _vm._v("\n        对\n        "),
          _c("router-link", {
            staticClass: "name-author",
            style: { color: _vm.mColor(4) },
            attrs: {
              tag: "span",
              to: {
                name: "label-detail",
                params: { label: _vm.work_id, tab: 0 }
              }
            },
            domProps: { textContent: _vm._s(_vm.tagName) }
          }),
          _vm._v("\n        的" + _vm._s(_vm.typeName) + "\n    ")
        ],
        1
      ),
      _vm._t("default")
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }